/**
 * The backend leaves `status` at "pending" once the files are in, so
 * `submitted` is what separates "not started" from "waiting on us". Shared by
 * the KYC page and the section's progress rail, which must never disagree.
 */
export const kycStatusOf = (data) => {
  const reported = data?.status ?? 'pending';
  return reported === 'pending' && data?.submitted ? 'under_review' : reported;
};

/** Headline per resolved status — `pending` is an account that hasn't submitted. */
export const KYC_TITLE = {
  pending: 'Not started',
  under_review: 'Under review',
  approved: 'Verified',
  rejected: 'Action needed',
};
